/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   actions.ts
 */

import { sliceSavedCustomMessage } from './slice'
export const { setCustomMessageChecked, resetState } = sliceSavedCustomMessage.actions
